import { render } from "./app.vue?vue&type=template&id=4a77e5ae"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/Users/agostinodegirolamo/Dropbox/Mac/Documents/Progetti/TTRE/Rapportino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__